import Card from '../card';

/**
 * The AboutWebsite component is used on the About page to show information about
 * the website itself.
 *
 * props: none
 */

const AboutWebsite = () => (
	<Card cardTitle="Website">
		<p>This website presents weather information as recorded by the weather station. It is hosted locally,
			in central Auckland.
		</p>

		<p>The website has been rebuilt in late 2018 as a mobile-friendly Progressive Web App. This means
			it is very fast and efficient, caching many resources to reduce your data usage. It also means
			you can add it to the home screen on Android phones, and the website will launch just like a
			native app.
		</p>
	</Card>
);

export default AboutWebsite;



// WEBPACK FOOTER //
// ./components/about/about-website.js